$color-label-grey: rgba(0, 0, 0, 0.5);
$color-day-header-grey: #ccd2dd;

table th.rate {
  color: black;
  text-transform: uppercase;
  display: inline-block;
  width: 80px;
  padding-bottom: 0px !important;
  padding-left: 0px !important;
  margin-bottom: -1rem;
  font-family: Lato;
  font-size: 14px !important;
  font-weight: bold;
  letter-spacing: 0.26px;
  line-height: 17px;
}

.mobileTimesheet__header {
  background-color: $color-day-header-grey;
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  font-size: 0.9rem;
}

.notBooked {
  margin-bottom: 1rem;
}

.mobileTimesheet__day {
  width: calc(100% + 2rem);
  margin-left: -1rem;
}

.mobileTimesheet__rates {
  font-size: 0.8rem;
  margin-bottom: 1rem;

  &:last-of-type {
    margin: 0;
  }
}

.mobileTimesheet__rate {
  padding: 1rem;
  border: 1px solid #dcdcdc;
  border-bottom: none;
}

.mobileTimesheet__rateDisplayName {
  padding-right: 0.4rem;
}

.mobileTimesheet__dayTotal {
  padding-right: 0.5rem;
}

.btnSave {
  margin-right: 1rem;
  position: absolute;
  top: 65px;
  left: 420px;
}
